// extracted by mini-css-extract-plugin
export default {"root":"IconSuccess_root__2FvOj","fillColor":"IconSuccess_fillColor__TRCpk","checkmark":"IconSuccess_checkmark__0VOkZ"};